import React from 'react';
import { useTranslation } from 'react-i18next';

import { AcceptHigherMultiplerSwitch } from '@/components/AcceptHigherMultiplierSwitch';
import { AcceptMultiplierChangeSwitch } from '@/components/AcceptMultiplierChangeSwitch';
import { ClassicModeSwitch } from '@/components/ClassicModeSwitch';
import { ProjectionChangeSwitch } from '@/components/ProjectionChangeSwitch';
import { ScrollableScreen } from '@/components/ScrollableScreen';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { AccountDetailsRow } from '@/feature/account-details/components/AccountDetailsRow';
import { EdgeComboSwitch } from '@/feature/betslip-pickem/components/EdgeComboSwitch';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';
import { useIsSweepsOrPredictionsProduct } from '@/hooks/use-is-sweeps-or-predictions-product';
import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const PreferencesScreen = () => {
    const { t } = useTranslation(['preferences', 'edge_combo_modal']);

    const product = useJurisdictionStore.getState().product;
    const settings = useJurisdictionStore(state => state.jurisdictionSettings?.productConfig?.settings);
    const enabledHigherMultipliers = settings?.higher_multiplier_toggle_enabled;
    const isPredictions = useIsPredictionsProduct();
    const isSweepsOrPredictions = useIsSweepsOrPredictionsProduct();

    return (
        <ScrollableScreen
            screenNavBarProps={{ title: t('preferences') }}
            scrollViewProps={{ style: { paddingHorizontal: 0 } }}
        >
            <MaxWidthWrapper paddingHorizontal={'s16'}>
                <SizedBox value={8} />
                <Text variant="headlineMedium">{t('preferences_title')}</Text>
                <SizedBox value={12} />

                {isSweepsOrPredictions ? (
                    <>
                        <AccountDetailsRow
                            label={t(isPredictions ? 'accept_all_price' : 'accept_all_multiplier')}
                            renderAction={() => <AcceptMultiplierChangeSwitch />}
                        />
                        <SizedBox value={12} />
                        {enabledHigherMultipliers ? (
                            <AccountDetailsRow
                                label={t(isPredictions ? 'accept_only_higher_price' : 'accept_only_higher_mutiplier')}
                                renderAction={() => <AcceptHigherMultiplerSwitch />}
                            />
                        ) : null}
                        <SizedBox value={12} />
                        {isPredictions ? null : (
                            <AccountDetailsRow label={t('classic_mode')} renderAction={() => <ClassicModeSwitch />} />
                        )}
                    </>
                ) : product === Product.Pickem ? (
                    <>
                        <AccountDetailsRow
                            label={t('gameplay')}
                            subLabel={t('always_accept_projection_changes')}
                            renderAction={() => <ProjectionChangeSwitch displayMode={'preferences'} />}
                        />
                        <AccountDetailsRow
                            label={t('gameplay')}
                            subLabel={t('edge_combo_modal:always_make_edge_combo')}
                            renderAction={() => <EdgeComboSwitch displayMode={'preferences'} />}
                        />
                    </>
                ) : null}
            </MaxWidthWrapper>
        </ScrollableScreen>
    );
};
